import React from 'react'
import useImgLink from './hooks/useImgLink'
import style from './Image.module.scss'
import { Bakery } from 'media/icons'

export const ImageWithoutLink = ({ isLoading, src, width, ...props }) => {
	return !isLoading ?
		<img {...props} alt='' src={src} className={style.root}/> :
		<div {...props} className={style.placeholder}>
			<Bakery/>
		</div>
}

const ImageWithLink = (props) => {
	const { src, isLoading } = useImgLink(props)
	return <ImageWithoutLink {...props} isLoading={isLoading} src={src}/>
}

export default ImageWithLink
